<template>
  <v-form :style="{ height: '100vh', backgroundColor: isConfirmed ? '#ffffff' : '' }">
    <v-overlay :dark="false" :absolute="true" :value="overlayValidation">
      <v-progress-circular color="primary" :size="70" width="7" indeterminate />
    </v-overlay>
    <v-container class="login-container" fluid>
      <v-row style="height: 100% !important;">
        <v-col class="pa-12 d-flex align-center" :cols="isConfirmed ? 5 : 6">
          <v-container :class="{ 'ml-12': !isConfirmed, 'confirmation-container': isConfirmed }" fluid>
            <v-row>
              <v-col :cols="12">
                <v-img v-if="isConfirmed" src="@/assets/Logo_Main.svg" max-width="250px" contain />
                <h1 class="white-content" :style="{ color: isConfirmed ? '#111111 !important' : '' }"
                  v-html="$t(isConfirmed ? 'confirmedTitle' : 'title')">
                </h1>
                <p :style="{ color: isConfirmed ? '#111111 !important' : '' }">
                  {{ $t(isConfirmed ? 'confirmedSubtitle' : (email.includes('@') ? 'subtitleForEmail' :
                    'subtitleForUsername'),
                    { emailOrUsername: this.email }) }}
                </p>
                <p v-if="!isConfirmed">
                  {{$t('spamText')}}
                </p>
              </v-col>
              <v-col cols="12">
                <div class="activation-code-container">
                  <input v-for="(digit, index) in 6" :key="index" v-model="codeDigits[index]" type="text" maxlength="1"
                    class="activation-code-input" :class="{ 'confirmed': isConfirmed }"
                    @input="handleInput($event, index)" @keydown="handleKeydown($event, index)" @paste="handlePaste"
                    ref="codeInputs" :disabled="isConfirmed">
                </div>
              </v-col>
            </v-row>
            <v-row v-if="!isConfirmed">
              <v-col cols="6">
                <p v-if="!canResendEmail" class="label">
                  {{ $t('messagePreEnableBtn', { seconds: secondsBeforeResend }) }}
                </p>
                <v-btn class="secondary" v-else @click="sendAnotherEmail">
                  {{ $t('sendEmailBtn') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col :class="{ 'confirmation-right-panel': isConfirmed, 'signup-image': !isConfirmed }"
          :cols="isConfirmed ? 7 : 6">
          <div v-if="isConfirmed" class="animation-container">
            <lottie :options="lottieOptions" :height="542" :width="483" />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Error Modal -->
    <v-dialog v-model="showErrorModal" max-width="400">
      <v-card>
        <v-card-title class="headline error-title">
          {{ $t('errorModal.title') }}
        </v-card-title>
        <v-card-text class="error-content py-4">
          {{ $t('errorModal.message') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showErrorModal = false">
            {{ $t('errorModal.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import * as animationData from '@/assets/animations/rocket.json';
import Repository from '../../../repositories/auth';
import { mapMutations } from "vuex";

export default {
  name: "ConfirmedEmail",
  props: {
    email: String,
    password: String,
    referredFrom: Boolean,
    highlight: String,
    comeFrom: String,
  },
  data() {
    return {
      codeDigits: ['', '', '', '', '', ''],
      key: '',
      overlayValidation: false,
      secondsBeforeResend: 60,
      canResendEmail: false,
      titleMessage: this.$t('titleMessage1'),
      bodyMessage: this.$t('bodyMessage1'),
      isConfirmed: false,
      lottieOptions: {
        animationData: animationData.default,
      },
      showErrorModal: false,
    };
  },
  watch: {
    codeDigits: {
      handler(newVal) {
        this.key = newVal.join('');
      },
      deep: true
    },
    key() {
      if (String(this.key).length === 6)
        this.validateEmail();
    },
  },
  created() {
    if (this.comeFrom === "LoginError") {
      this.sendAnotherEmail(false);
    }
    this.setTimerEmailResend();
    if (this.email === undefined)
      this.$router.push('/');
  },
  computed: {
    _seconds() {
      return 1000;
    },
  },
  methods: {
    handleInput(event, index) {
      const value = event.target.value;
      if (!/^[0-9]$/.test(value)) {
        this.codeDigits[index] = '';
        return;
      }

      this.codeDigits[index] = value;
      if (index < 5 && value) {
        this.$refs.codeInputs[index + 1].focus();
      }
    },

    handleKeydown(event, index) {
      if (event.key === 'Backspace' && !this.codeDigits[index] && index > 0) {
        this.$refs.codeInputs[index - 1].focus();
      }
    },

    handlePaste(event) {
      event.preventDefault();
      const pastedText = event.clipboardData.getData('text');
      const numbers = pastedText.replace(/[^0-9]/g, '').slice(0, 6);

      if (numbers.length > 0) {
        this.codeDigits = [...numbers.padEnd(6, '').split('')];
        if (numbers.length === 6) {
          this.$refs.codeInputs[5].focus();
        } else {
          this.$refs.codeInputs[numbers.length].focus();
        }
      }
    },
    setTimerEmailResend() {
      this.canResendEmail = false;
      this.secondsBeforeResend = 60;
      let endTime = new Date();
      endTime.setSeconds(endTime.getSeconds() + 61);
      const timer = setInterval(() => {
        let now = new Date();
        let distance = endTime.getTime() - now.getTime();
        if (distance < 1) {
          this.canResendEmail = true;
          clearInterval(timer);
          return;
        }

        this.secondsBeforeResend = Math.floor(distance / this._seconds);
      }, 1000);
    },
    validateEmail() {
      this.overlayValidation = true;
      Repository.confirmedEmail(this.email, this.key).then((response) => {
        this.overlayValidation = false;
        if (response.status < 400) {
          this.isConfirmed = true;
          setTimeout(() => {
            if (this.password !== undefined)
              this.goToDashboard();
            else
              this.goToLogin();
          }, 5000);
        } else {
          this.showErrorModal = true;
        }
      }).catch(() => {
        this.overlayValidation = false;
        this.showErrorModal = true;
      });
    },
    sendAnotherEmail() {
      Repository.requestActivationKey(this.email).then((response) => {
        if (response.status < 400) {
          this.setTimerEmailResend();
        }
      });
    },
    ...mapMutations(['setToken', 'setUser', 'setUserDetails', 'setPreferredLanguage']),
    async goToDashboard() {
      this.overlayValidation = true;
      // Set theme to light
      this.$vuetify.theme.dark = false;
      localStorage.setItem("theme-preference", "light");

      Repository.login(this.email, this.password).then(async (response) => {
        if (response.status < 250) {
          this.setToken(`Bearer ${response.data.id_token}`);
          await Repository.getUser().then((response) => { this.setUser(response.data); });
          await Repository.getLanguage().then((response) => { this.setPreferredLanguage(response.data); });
          await Repository.getUserDetails().then((response) => { this.setUserDetails(response.data); });
          await Repository.analyzeNewUserLogin(this.$store.state.user.id);
          if (this.referredFrom) {
            this.$router.push({
              name: 'subscription-plans',
              params: {
                // userId: Number.parseInt(secondResponse.data.id),
                highlight: this.highlight,
                // discount: Number.parseInt(this.discount)
              }
            });
          } else {
            await this.$router.push({
              name: 'integrations',
            });
          }
        }
      }).catch((error) => {
        if (error.response.data.status === 401)
          this.goToLogin();
      });
    },
    goToLogin() {
      this.$router.push('/');
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

@import "src/global.scss";

#app .white-content,
#app h3 {
  color: $white-color;
}

.light-grey-content {
  color: $light-gray-color;
}

.activation-code-container {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  margin: 0;
}

.activation-code-input {
  width: 50px;
  height: 50px;
  border: 1px solid $light-gray-color;
  border-radius: 8px;
  font-size: 24px;
  text-align: center;
  background-color: transparent;
  color: $white-color;

  &:focus {
    outline: none;
    border-color: $primary-color;
  }

  &.confirmed {
    background-color: #DCDCDC;
    border-color: #DCDCDC;
    color: #111111;
    cursor: not-allowed;
  }
}

.v-text-field {
  display: none;
}

.v-input__icon--append .v-icon {
  color: #929292 !important;
  border: none !important;
}

.v-input__icon--append .v-icon:hover {
  color: #929292;
  background-color: rgba(85, 85, 85, 0);
  border: none;
}

.login-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.signup-image {
  padding: 0;
  background-color: #111111;
  background-image: url("https://hub.swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}

.confirmation-right-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;

  .animation-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.confirmation-container {
  padding: 0 48px !important;
  margin: 0 !important;
  max-width: 100% !important;
}

.text-center {
  text-align: center !important;
}

.error-title {
  color: #DC3545 !important;
  padding: 16px;
}

.error-content {
  font-size: 16px;
  color: #111111;
}
</style>


